<template>

    <m-edit1/>

    <m-n2-header v-bind='{...{"image":"https:\/\/api.cafen2.ir\/storage\/assets\/header-section-image.ed15f31b.png","alt":"cafe n2","buttonName":"\u062d\u0633\u0627\u0628 \u06a9\u0627\u0631\u0628\u0631\u06cc","buttonLink":"https:\/\/dash.cafen2.ir\/dashboard"},...{}}' :style='""' class="" ></m-n2-header><m-language-changer-1 v-bind='{...{"showLanguageName":false},...{}}' :style='""' class="text-center mb-5" ></m-language-changer-1><m-product-tags-discover-309 v-bind='{...{"messages":["\u063a\u0630\u0627\u06cc \u062a\u0646\u062f \u062f\u0648\u0633\u062a \u062f\u0627\u0631\u06cc\u061f","\u0646\u0645\u06cc\u062f\u0648\u0646\u06cc \u0686\u06cc \u0628\u062e\u0648\u0631\u06cc\u061f!","\u0647\u0648\u0633 \u0686\u06cc\u0632 \u062e\u0646\u06a9 \u06a9\u0631\u062f\u06cc\u061f"],"rotateInterval":2800,"perPage":12,"productCardName":"mProductCard525","tagType":"product"},...{}}' :style='""' class="" ></m-product-tags-discover-309><m-products-302 v-bind='{...{"paginate":false,"perPage":35,"productCardName":"mProductCard208","showSpecifiedCardFeature":""},...{}}' :style='""' class="container" ></m-products-302><m-n2-contact-us v-bind='{...{"image":"https:\/\/api.cafen2.ir\/storage\/assets\/instagram.d8a39059.png","alt":"cafe n2"},...{}}' :style='""' class="" ></m-n2-contact-us><m-world-map v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>default   </template>
                </m-world-map>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mN2Header from '@moeinmdn/miw-alpha-components/src/package/FancyComponent/N2Header'; import mLanguageChanger1 from '@moeinmdn/miw-alpha-components/src/package/Language/LanguageChanger/LanguageChanger1'; import mProductTagsDiscover309 from '@moeinmdn/miw-alpha-components/src/package/Product/Component/ProductTagsDiscover309/ProductTagsDiscover309'; import mProducts302 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products302/Products302'; import mN2ContactUs from '@moeinmdn/miw-alpha-components/src/package/FancyComponent/N2ContactUs'; import mWorldMap from '@moeinmdn/miw-alpha-components/src/package/FancyComponent/WorldMap';

export default {
    name: 'HomeView',
    components: {mEdit1, mN2Header,mLanguageChanger1,mProductTagsDiscover309,mProducts302,mN2ContactUs,mWorldMap },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
